export default {
  heading: "'Gill Sans', 'Gill Sans MT', 'Calibri', sans-serif",
  body: "'Inter', 'Segoe UI', 'Roboto', sans-serif",
  sizes: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '24px',
    xxl: '32px',
    hero: '48px',
  },
};
